import Photo from "./Photo";
import Reveal from "./Reveal";
import useI18n from "@/i18n";

export default function CommentCaSePasse() {
    const { t } = useI18n();
    return (
        <section id="comment" className="grad-down scroll-mt-24 py-16 md:py-24" data-testid="comment-section">
            <div className="mx-auto max-w-[1080px] px-5">
                <Reveal>
                    <p className="eyebrow">{t.parcours.eyebrow}</p>
                    <h2 className="text-3xl text-terrat md:text-4xl">{t.parcours.h2}</h2>
                    <hr className="rule-gold mt-4 w-16" />
                    <p className="mt-4 max-w-[52ch] text-lg text-ink2">{t.parcours.lead}</p>
                </Reveal>
                <Reveal delay={0.1}>
                    <Photo
                        file="mur.jpg"
                        alt={t.parcours.photoAlt}
                        legend={t.parcours.photoLegend}
                        position="50% 30%"
                        ratioClass="aspect-[4/3] rounded-[18px] md:aspect-[16/9]"
                        className="mt-10"
                    />
                </Reveal>
                <div className="mt-12 grid gap-6 md:grid-cols-3">
                    {t.parcours.steps.map(([title, text], i) => (
                        <Reveal key={title} delay={i * 0.08}>
                            <div className="card card-motif h-full p-7">
                                <span
                                    aria-hidden="true"
                                    className="title-grad font-display text-5xl"
                                >
                                    {i + 1}
                                </span>
                                <h3 className="mt-3 text-xl text-olivet">{title}</h3>
                                <hr className="rule-gold mt-3 w-12" />
                                <p className="mt-3">{text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
